'use client';

import { Dispatch, SetStateAction, useMemo } from 'react';
import { cn } from '@/helpers/common';
import IconKebab from '@/components/svgs/icons/kebab-icon';

import { ROUTES } from '@/constants/routes/default';
import { signOut } from 'next-auth/react';
import Dropdown from '../Dropdowns/Dropdown';

const HeaderDropdownJC = ({ session }: { session: any }) => {
  const options = useMemo(() => {
    let result = [];

    if (session) {
      result = [
        { type: 'link', title: 'Search Jobs', href: ROUTES.jobs, withDivider: true },
        {
          type: 'link',
          title: 'Work Preferences',
          href: ROUTES.profile,
          withDivider: false,
        },
        {
          type: 'link',
          title: 'Partnership',
          href: ROUTES.partners,
          withDivider: false,
        },
        {
          type: 'button',
          title: 'Sign Out',
          onClick: () => signOut(),
          withDivider: true,
        },
      ];
    } else {
      result = [
        {
          type: 'link',
          title: 'Search Jobs',
          href: ROUTES.jobs,
          withDivider: !!session,
        },
        {
          type: 'link',
          title: 'Partnership',
          href: ROUTES.partners,
          withDivider: false,
        },
        {
          type: 'link',
          title: 'Sign In',
          href: ROUTES.signin,
          withDivider: false,
        },
        {
          type: 'link',
          title: 'Create Profile',
          href: ROUTES.signup,
          withDivider: false,
        },
      ];
    }

    return result;
  }, [session]);

  return (
    <Dropdown
      rootCn={''}
      listCn={'max-w-50 right-0 bg-white py-2 rounded-md jc-shadow1'}
      elementCn={'text-sm h-9 px-4 flex items-center hover:bg-jc-white-lilac'}
      dividerCn={'border-jc-botticelli'}
      listHeader={
        session && session?.user?.email ? (
          <div
            className={cn(
              'px-4 text-xs text-jc-trout overflow-hidden truncate whitespace-nowrap text-ellipsis',
            )}
          >
            {session?.user?.email}
          </div>
        ) : null
      }
      options={options}
    >
      {({
        setIsOpen,
        isOpen,
        listId,
      }: {
        setIsOpen: Dispatch<SetStateAction<boolean>>;
        isOpen: boolean;
        listId: string;
      }) => (
        <button
          aria-label="Menu"
          aria-expanded={isOpen}
          aria-controls={isOpen ? listId : undefined}
          onClick={() => {
            setIsOpen((prev) => !prev);
          }}
          className={cn(
            'flex items-center justify-center relative p-2 [&>svg>path]:fill-jc-firefly! no-underline default-transition rounded-md bg-jc-my-sin hover:bg-jc-tangerine',
            isOpen && 'bg-jc-tangerine',
          )}
        >
          <IconKebab
            aria-hidden="true"
            className="shrink-0 [&>rect]:fill-current [&>rect]:transition-all [&>rect]:duration-300"
          />
        </button>
      )}
    </Dropdown>
  );
};

export default HeaderDropdownJC;
